export default new Proxy({}, {
  get(_, key) {
    throw new Error(`Module "process" has been externalized for browser compatibility. Cannot access "process.${key}" in client code.`)
  }
})